var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.window.is.desktop)?_c('com-desktop',{attrs:{"head":_vm.head},on:{"search":function($event){return _vm.$emit('search')}}}):_vm._e(),(!_vm.window.is.desktop)?_c('com-device',{attrs:{"head":_vm.head},on:{"search":function($event){return _vm.$emit('search')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }